export default __webpack_public_path__ + "static/media/black-burger.b0082d4b.svg";